import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ForkLiftIcon } from './icons/ForkLiftIcon';
import { QerkoLogoIcon } from './icons/QerkoLogoIcon';

const sxButton = {
    backgroundColor: '#00B579',
    borderRadius: '8px',
    color: 'white',
    fontFamily: 'Space Grotesk',
    fontFeatureSettings: '"liga" off',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 'bold',
    letterSpacing: '0.2px',
    lineHeight: '22px',
    p: '1rem',
    textAlign: 'center',
    textTransform: 'initial',
    width: '312px',
} as const;

const isInViewport = (el: Element) => {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

export const InstaApp = ({
    urlRestaurantBackgroundPlaceholder,
    urlRestaurantBackground,
    urlRestaurantLogo,
    urlPayByQerkoApp,
    restaurantName,
}: {
    urlRestaurantBackgroundPlaceholder: string;
    urlRestaurantBackground: string | null;
    urlRestaurantLogo: string | null;
    urlPayByQerkoApp: string;
    restaurantName: string | undefined;
}) => {
    const [isRendered, setIsRendered] = useState(false);
    const { t } = useTranslation('instaApp');

    useEffect(() => {
        /**
		 * Some devices have small screen. If is not buttonElement in viewport then scroll down.
		 */
        if (isRendered) return;

        const buttonElement = document.querySelector('#buttonContinue');

        if (buttonElement !== null && !isInViewport(buttonElement)) window.scrollBy(0, 1000);
        else setIsRendered(true);

    }, [isRendered]);

    return (
        <>
            <Box sx={{
                backgroundImage: `url('${urlRestaurantBackground ? urlRestaurantBackground : urlRestaurantBackgroundPlaceholder}')`,
                backgroundPosition: 'center',
                height: '246px',
                position: 'relative',
                width: '100%',
            }}
            >
                <Box sx={{
                    backgroundColor: 'white',
                    borderRadius: '16px',
                    bottom: '-90px',
                    boxSizing: 'border-box',
                    height: '160px',
                    left: 0,
                    ml: 'auto',
                    mr: 'auto',
                    position: 'absolute',
                    right: 0,
                    width: '160px',
                }}
                >
                    <Box sx={{
                        borderRadius: '8px',
                        height: '160px',
                        width: '160px',
                    }}
                    >
                        {!urlRestaurantLogo && (

                            <Box sx={{ backgroundColor: '#F4F6F5', borderRadius: '16px', height: '136px', m: '12px 12px', width: '136px' }}>
                                <ForkLiftIcon sx={{
                                    height: '60px',
                                    ml: '45px',
                                    mt: '45px',
                                    width: '46px',
                                }}
                                />
                            </Box>
                        )}
                        {urlRestaurantLogo && (
                            <img alt="Restaurant logo" src={urlRestaurantLogo} style={{ borderRadius: '16px', height: '160px', width: '160px' }} />
                        )}
                    </Box>
                </Box>
            </Box>

            <Box sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                mt: '90px',
                textAlign: 'center',
            }}
            >
                <Typography sx={{
                    color: '#98A6AE',
                    fontFamily: 'Space Grotesk',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    letterSpacing: '1px',
                    lineHeight: '24px',
                    mt: '8px',
                    textAlign: 'center',
                    textTransform: 'uppercase',
                }}
                >
                    {restaurantName}
                </Typography>

                <Typography sx={{
                    color: '#2D2533',
                    fontFamily: 'Space Grotesk',
                    fontSize: '32px',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    lineHeight: '44px',
                }}
                >
                    {t('welcomeInRestaurant')}
                </Typography>

                <Typography sx={{
                    fontFamily: 'Space Grotesk',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    lineHeight: '24px',
                }}
                >
                    {t('payEasilyByMobilephone')}
                </Typography>

                <Typography sx={{
                    alignItems: 'center',
                    color: '#98A6AE',
                    display: 'flex',
                    fontFamily: 'Space Grotesk',
                    fontFfeatureSettings: '\'liga\' off',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    lineHeight: '24px',
                    mt: '77px',
                }}
                >
                    {t('byAppQerko')} <QerkoLogoIcon sx={{ height: '26px', ml: '12px', width: '87px' }} />
                </Typography>
                <Button
                    href={urlPayByQerkoApp}
                    id="buttonContinue"
                    rel="noreferrer"
                    sx={{
                        '&:active': sxButton,
                        '&:focus-visible': sxButton,
                        '&:focus-within': sxButton,
                        '&:hover': sxButton,
                        mb: '5rem',
                        ...sxButton,
                    }}
                    target="_blank"
                    variant="contained"
                >
                    {t('continue')}
                </Button>
            </Box>
        </>
    );
};
